import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-helpbutton-departments-dashboard',
  templateUrl: './helpbutton-departments-dashboard.component.html',
  styleUrls: ['./helpbutton-departments-dashboard.component.scss']
})
export class HelpbuttonDepartmentsDashboardComponent implements OnInit, OnDestroy {

  departments;
  noItemsConfig;
  viewDisposition = 'grid';
  getDepartmentsSubscriptionRefresh: Subscription;
  getDepartmentsSubscription: Subscription;
  searchDepartmentsSubscription: Subscription;
  filterDepartmentsSubscription: Subscription;
  toggleDepartmentsDispositionSubscription: Subscription;
  filterKey;
  filterOpts;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private departmentsService: DepartmentsHelpbuttonService,
    private snackbarService: SnackBarService,
    private cd: ChangeDetectorRef,
    private headerBreadcrumbService: HeaderBreadcrumbService) {
      this.noItemsConfig = this.setNoItemsConfig();
    }

  ngOnInit() {
    this.setBreadcrumb();
    this.getDepartments();
    this.getDepartmentsSubscriptionRefresh = this.departmentsService.refreshDepartmentsListen().subscribe(
      (res) => {
        this.getDepartments();
      }
    );
    this.filterDepartmentsSubscription = this.departmentsService.filterDepartmentsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchDepartmentsSubscription = this.departmentsService.searchDepartmentsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleDepartmentsDispositionSubscription = this.departmentsService.toggleDepartmentsDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getDepartments() {
    this.getDepartmentsSubscription = this.departmentsService.getDepartments().subscribe(
      (res) => {
        this.departments = res;
      },
      (error) => {
        this.departments = '-';
        this.router.navigate(['../../'], {relativeTo: this.activatedRoute});
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-columns', 'helpbutton-page.departments', '/helpbutton', [new BRoute('helpbutton-page.helpbutton', '/helpbutton'), new BRoute('helpbutton-page.departments')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'helpbutton-page.sections not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getDepartmentsSubscriptionRefresh) { this.getDepartmentsSubscriptionRefresh.unsubscribe(); }
    if (this.getDepartmentsSubscription) { this.getDepartmentsSubscription.unsubscribe(); }
    if (this.searchDepartmentsSubscription) { this.searchDepartmentsSubscription.unsubscribe(); }
    if (this.filterDepartmentsSubscription) { this.filterDepartmentsSubscription.unsubscribe(); }
    if (this.toggleDepartmentsDispositionSubscription) { this.toggleDepartmentsDispositionSubscription.unsubscribe(); }
  }

}
